angular.module(["ng"]).run(["$templateCache", function (c) {
    c.put("popup-alert-template.html", "<div class=\"modal fade custom-width\" id=\"popupAlert\"> <div class=\"modal-dialog mini-dialog\"> <div class=\"modal-content\"> <div class=\"modal-header\" style=\"background-color: #ddd\"> <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</button> <h4 class=\"modal-title\">{{alert.title}}</h4> </div> <div class=\"modal-body\"> <p>{{alert.content|translate}}</p> </div> </div> </div> </div>");
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/modals/popup-alert-template.html
 ** module id = 149
 ** module chunks = 0
 **/